// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0f5d77","secondary":"#f59120"};